(function($) { 

  const $downloadres = $('.ShortCode.Resources a.Download')
  $downloadres.on(
    'click',
    function() {

      const $this = $(this)
      const title = $this.attr('title')
      const userid = window.academystatus.userid
      const postid = window.academystatus.postid
      const token = window.tag
      const url = '/wp-json/academy/userdata/event'
      const body = JSON.stringify({ 
        user_id: userid,
        event_type: 'resource',
        course_id: postid,
        resource_title: title
      })

      fetch(
        url,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-WP-Nonce': academy_web_site.nonce
          },
          body: body
        }
      )
    }
  ) 

  const $sharesocial = $('body.single-course .WidgetSocialIcons .wp-block-social-link-anchor')
  $sharesocial.on(
    'click',
    function() {

      const $this = $(this)

      const $liparent = $this.parents('.wp-block-social-link').eq(0)
      const social = $liparent.hasClass('Facebook') ?
        'Facebook'
        :
        $liparent.hasClass('Twitter') ?
          'Twitter'
          :
          $liparent.hasClass('Mail') ?
            'Mail'
            :
            ''

      const userid = window.academystatus.userid
      const postid = window.academystatus.postid
      const token = window.tag
      const url = '/wp-json/academy/userdata/event'
      const body = JSON.stringify({ 
        user_id: userid,
        event_type: 'share',
        course_id: postid,
        social_network: social
      })

      fetch(
        url,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-WP-Nonce': academy_web_site.nonce
          },
          body: body
        }
      )
    }
  )

})(jQuery)